/**
 * Long-load overlay state.
 * Shows a message when API requests take longer than LONG_LOAD_THRESHOLD_MS.
 */

export const LONG_LOAD_THRESHOLD_MS = 10; // 1 minute

export const LONG_LOAD_REQUEST_START = 'app/longLoad/REQUEST_START';
export const LONG_LOAD_REQUEST_END = 'app/longLoad/REQUEST_END';
export const LONG_LOAD_SHOW = 'app/longLoad/SHOW';

const initialState = {
  showOverlay: false,
  pendingCount: 0,
};

export default function longLoadReducer(state = initialState, action) {
  switch (action.type) {
    case LONG_LOAD_REQUEST_START:
      return {
        ...state,
        pendingCount: state.pendingCount + 1,
      };
    case LONG_LOAD_REQUEST_END: {
      const newPending = Math.max(0, state.pendingCount - 1);
      const success = action.payload?.success === true;
      return {
        ...state,
        pendingCount: newPending,
        showOverlay: success
          ? false
          : newPending === 0
            ? false
            : state.showOverlay,
      };
    }
    case LONG_LOAD_SHOW:
      return {
        ...state,
        showOverlay: true,
      };
    default:
      return state;
  }
}
